import { Switch as HeadlessSwitch } from '@headlessui/react';

import Container from '@/components/@base/container';
import { CONTAINER_TAG_TYPE } from '@/components/@base/container/type';

import Props from './type';

export default function Switch({ onChange, checked = false, ...props }: Props) {
  return (
    <HeadlessSwitch
      {...props}
      dir='ltr'
      checked={checked}
      onChange={onChange}
      className={`${
        checked ? 'bg-[#FF9606]' : 'bg-gray-200'
      } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-hidden`}
    >
      <Container
        type={CONTAINER_TAG_TYPE.SPAN}
        className={`${
          checked ? 'translate-x-6' : 'translate-x-1'
        } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
      />
    </HeadlessSwitch>
  );
}
